import { render, staticRenderFns } from "./Clock.vue?vue&type=template&id=22ac3932&scoped=true&"
import script from "./Clock.vue?vue&type=script&lang=js&"
export * from "./Clock.vue?vue&type=script&lang=js&"
import style0 from "./Clock.vue?vue&type=style&index=0&id=22ac3932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac3932",
  null
  
)

component.options.__file = "Clock.vue"
export default component.exports